// Cart Handler JavaScript
(function() {
  'use strict';
  
  // Debounce utility
  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  }
  
  // Fetch cart data
  async function fetchCartData() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error('Error fetching cart:', error);
      return null;
    }
  }
  
  // Update cart count in UI
  function updateCartCount(count) {
    // Update all cart count elements
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = count;
    });
    
    // Toggle cart button container visibility
    const container = document.getElementById('cart-button-container');
    if (container) {
      container.classList.toggle('hidden', count === 0);
    }
    
    // Update notification count
    const notificationCount = document.getElementById('cart-notification-count');
    if (notificationCount) {
      notificationCount.textContent = count;
    }
    
    // Toggle cart links enabled/disabled state
    const cartLinks = document.querySelectorAll('[data-cart-link]');
    cartLinks.forEach(link => {
      if (count === 0) {
        // Disable cart link
        link.classList.add('pointer-events-none');
      } else {
        // Enable cart link
        link.classList.remove('pointer-events-none');
      }
    });
  }
  
  // Update cart contents (debounced)
  const updateCartContents = debounce(async () => {
    const cart = await fetchCartData();
    if (cart) {
      updateCartCount(cart.item_count || 0);
    }
  }, 300);
  
  // Show notification
  function showNotification() {
    const notification = document.querySelector('.notification');
    if (notification) {
      notification.classList.remove('translate-y-full');
      setTimeout(closeNotification, 5000);
    }
  }
  
  // Close notification
  function closeNotification() {
    const notification = document.querySelector('.notification');
    if (notification) {
      notification.classList.add('translate-y-full');
    }
  }
  
  // Handle add to cart
  async function addToCart(event) {
    event.preventDefault();
    
    const form = event.target.closest('form');
    if (!form) return;
    
    const submitButton = form.querySelector('[type="submit"]');
    if (!submitButton) return;
    
    // Set loading state
    submitButton.classList.add('is-loading');
    submitButton.disabled = true;
    
    try {
      const formData = new FormData(form);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      
      if (!response.ok) {
        const error = await response.json().catch(() => ({ message: 'Unknown error' }));
        throw new Error(error.message || `HTTP ${response.status}`);
      }
      
      await response.json();
      showNotification();
      updateCartContents();
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('There was an error adding the item to your cart. Please try again.');
    } finally {
      submitButton.classList.remove('is-loading');
      submitButton.disabled = false;
    }
  }
  
  // Initialize
  function init() {
    // Add event listeners to all add to cart forms
    document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
      form.addEventListener('submit', addToCart);
    });
    
    // Initialize cart count
    updateCartContents();
  }
  
  // Expose closeNotification globally
  window.closeNotification = closeNotification;
  
  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(); 